import { getAdminOptions } from "@insite/shell/Services/AdminService";
import * as React from "react";
import { createContext, PropsWithChildren, useContext, useEffect, useState } from "react";

export interface AdminOptions {
    optiDam: {
        url: string;
        isEnabled: boolean;
        organizationId?: string;
    };
}

export const OptionsContext = createContext<AdminOptions>({} as any);

export const useOptionsContext = () => {
    return useContext(OptionsContext);
};

export const OptionsProvider = (props: PropsWithChildren<any>) => {
    const [options, setOptions] = useState<AdminOptions | undefined>();
    useEffect(() => {
        getAdminOptions().then(options => {
            setOptions(options);
        });
    }, []);

    if (!options) {
        return null;
    }

    return <OptionsContext.Provider value={options}>{props.children}</OptionsContext.Provider>;
};
